// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2rrvF","header":"PatientBlock_header__11R7Q","label":"PatientBlock_label__1osOW","option":"PatientBlock_option__1P29E"};